import { supabase } from './supabase';
import { asegurarSaldoLeido, leerBilleterasDeMarcas } from './saldo';
import { motivoDeBorradoBloqueado } from '../components/facturacionPorMarca/planesPorMarca';

/**
 * Borra una marca ADICIONAL: primero pasa sus productos a la principal y recién después borra
 * la fila. Si quedaran en null (como hacía el borrado antes), se colarían bajo TODAS las marcas
 * por el scoping `brand_id = activa OR brand_id IS NULL`; la FK `ON DELETE SET NULL` los
 * nulificaría al borrar la marca. Sin principal, el caller no llama (no hay a quién pasarlos).
 *
 * Es el borrado de Configuración → Marcas (`MisMarcasSection`) y el "Cancelar" del plan de una
 * marca nueva con facturación por marca (ADR-2026-10-28-marca-nueva-con-pago): un solo camino.
 * Tira el error de la base tal cual.
 *
 * Con facturación por marca mira la billetera ANTES de mover los productos: con plan (o con la
 * baja pendiente en Rebill) tira el mismo error que el trigger de la base (`P0001`, "Cancelá su
 * plan…") y no toca nada; si no puede leerla, tampoco sigue. Sin el saldo cacheado lo lee (es
 * lo que hace falta para saber la bandera; con el tope de 3 s, sin respuesta sigue como sin
 * bandera y el trigger es el respaldo). Sin bandera, las mismas dos escrituras de siempre
 * (ADR-2026-10-28-eliminar-marca-mira-la-billetera-primero).
 */
export async function eliminarMarca(brandId: string, principalId: string): Promise<void> {
  if ((await asegurarSaldoLeido())?.facturaPorMarca) {
    const motivo = motivoDeBorradoBloqueado((await leerBilleterasDeMarcas([brandId])).get(brandId));
    if (motivo) throw Object.assign(new Error(motivo), { code: 'P0001' });
  }

  const { error: reassignError } = await supabase
    .from('productos')
    .update({ brand_id: principalId })
    .eq('brand_id', brandId);
  if (reassignError) throw reassignError;

  const { error: delError } = await supabase
    .from('brand_profiles')
    .delete()
    .eq('id', brandId);
  if (delError) throw delError;
}
